import { JSX } from 'react'

import { IconProps } from '../../icon'

const Menu: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M19 24C19 26.4944 21.0185 28.5128 23.5128 28.5128C26.0072 28.5128 28.0256 26.4944 28.0256 24C28.0256 21.5056 26.0072 19.4872 23.5128 19.4872C21.0185 19.4872 19 21.5056 19 24ZM25.5641 24C25.5641 25.1323 24.6451 26.0513 23.5128 26.0513C22.3805 26.0513 21.4615 25.1323 21.4615 24C21.4615 22.8677 22.3805 21.9487 23.5128 21.9487C24.6451 21.9487 25.5641 22.8677 25.5641 24Z'
      fill='black'
    />
    <path
      d='M19 12.5128C19 15.0072 21.0185 17.0256 23.5128 17.0256C26.0072 17.0256 28.0256 15.0072 28.0256 12.5128C28.0256 10.0185 26.0072 7.99999 23.5128 7.99999C21.0185 7.99999 19 10.0185 19 12.5128ZM25.5641 12.5128C25.5641 13.6451 24.6451 14.5641 23.5128 14.5641C22.3805 14.5641 21.4615 13.6451 21.4615 12.5128C21.4615 11.3805 22.3805 10.4615 23.5128 10.4615C24.6451 10.4615 25.5641 11.3805 25.5641 12.5128Z'
      fill='black'
    />
    <path
      d='M19 35.4872C19 37.9815 21.0185 40 23.5128 40C26.0072 40 28.0256 37.9815 28.0256 35.4872C28.0256 32.9928 26.0072 30.9744 23.5128 30.9744C21.0185 30.9744 19 32.9928 19 35.4872ZM25.5641 35.4872C25.5641 36.6195 24.6451 37.5385 23.5128 37.5385C22.3805 37.5385 21.4615 36.6195 21.4615 35.4872C21.4615 34.3549 22.3805 33.4359 23.5128 33.4359C24.6451 33.4359 25.5641 34.3549 25.5641 35.4872Z'
      fill='black'
    />
  </svg>
)

export default Menu
